'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _lodash = require('lodash.shuffle');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

if (!nativeInputValueSetter) {
    nativeInputValueSetter = function nativeInputValueSetter(value) {
        this.value = value;
    };
}

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        _this.state = {
            animation: []
        };

        _this.anumationTimeouts = [];

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'componentWillUnmount', this).call(this);
            this.anumationTimeouts.map(function (timer) {
                return clearTimeout(timer);
            });
            return this;
        }
    }, {
        key: 'runAnimation',
        value: function runAnimation() {
            var _this2 = this;

            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var item = void 0,
                id = new Date().getTime();

            item = {
                id: id,
                top: event.currentTarget.offsetTop + event.currentTarget.offsetHeight / 2 - 14,
                left: event.currentTarget.offsetLeft + event.currentTarget.offsetWidth / 2 - 14
            };

            this.setState({ animation: [].concat(_toConsumableArray(this.state.animation), [item]) });

            var timer = setTimeout(function () {
                _this2.setState({ animation: _this2.state.animation.filter(function (a) {
                        return a.id !== id;
                    }) });
            }, 500);

            this.anumationTimeouts.push(timer);
        }
    }, {
        key: 'select',
        value: function select(value) {
            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var current = this.props.value === null || this.props.value === undefined ? '' : this.props.value;

            if (current.length < this.props.maxLength) {
                this.value = current + value;
            }

            this.runAnimation(event);

            return this;
        }
    }, {
        key: 'clearDigit',
        value: function clearDigit() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var current = this.props.value || '',
                value = void 0;

            if (current.length) {
                // remove last digit
                value = current.substr(0, current.length - 1);
            }

            value = !value || !value.length ? null : value;

            this.value = value;
            this.runAnimation(event);

            return this;
        }
    }, {
        key: 'clear',
        value: function clear(event) {
            this.value = null;
            this.runAnimation(event);
            return this;
        }
    }, {
        key: '_inputRef',
        value: function _inputRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }

            this.input = el;
        }
    }, {
        key: '_stringify',
        value: function _stringify() {
            if (this.props.value === null || this.props.value === undefined) {
                return '';
            } else {
                return this.props.value;
            }
        }
    }, {
        key: '_handleChange',
        value: function _handleChange() {
            if (typeof this.props.onChange === 'function') {
                var _props;

                (_props = this.props).onChange.apply(_props, arguments);
            }
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.error);
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.value;
        },
        set: function set(value) {
            nativeInputValueSetter.call(this.input, value || '');
            this.input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    // label
    label: '',
    // list storage
    collection: (0, _lodash2.default)([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]),
    // max pin length
    maxLength: 4,
    onChange: null,
    // inline style
    inline: false
};
Main.propTypes = {
    label: _propTypes2.default.string,
    maxLength: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    inline: _propTypes2.default.bool
};
Main.displayName = 'PinBlock';
exports.default = Main;